<div class="table-columns cols{{colCount}}{{#if divClass}} {{divClass}}{{/if}}">
	{{#each rows}}
	<div>
		{{#each items}}
		<div>{{this}}</div>
		{{/each}}
	</div>
	{{/each}}
</div>
